import { render, staticRenderFns } from "./GroupManagement.vue?vue&type=template&id=614f9dbc&scoped=true&"
import script from "./GroupManagement.vue?vue&type=script&setup=true&lang=js&"
export * from "./GroupManagement.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./GroupManagement.vue?vue&type=style&index=0&id=614f9dbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614f9dbc",
  null
  
)

export default component.exports